
import { Component, Prop, Vue } from 'vue-property-decorator';
import UIUtil from '@/utils/ui.util';
import GradientExternalLinkIcon from '@/components/icons/GradientExternalLinkIcon.vue';
import AccessGloboDialog from '@/components/KPIs/dialogs/AccessGloboDialog.vue';
import BlockedIcon from '@/components/icons/BlockedIcon.vue';

export interface ISectionCardData {
  link: string;
  title?: string;
  text?: string;
  customColors?: string[];
  fixedHeight?: number;
  externalLink?: boolean;
  blocked?: boolean;
  isNew?: boolean;
}

@Component({
  components: {
    GradientExternalLinkIcon,
    BlockedIcon,
    AccessGloboDialog,
  },
})
export default class SectionCategoriesKpiCard extends Vue {
  @Prop([String, Array]) private title?: string | string[];
  @Prop(String) text?: string;
  @Prop(String) link!: string;
  @Prop(Array) customColors?: string[];
  @Prop(Number) private fixedHeight?: number;
  @Prop({ default: false }) externalLink!: boolean;
  @Prop({ default: false }) blocked!: boolean;
  @Prop({ default: false }) isNew!: boolean;
  @Prop(Array) icons?: string[];
  @Prop({ default: false }) tagActive!: boolean;
  @Prop(String) tagText?: string;
  @Prop(Boolean) isAccessGloboButtonEnabled?: boolean;
  @Prop(String) accessGloboRuleName?: string;

  isHovered = false;
  idSuffixGradientIcon: string = Math.random().toString(36).slice(2, 10);

  get cardTitle(): string {
    if (!this.title) return '';
    return Array.isArray(this.title) ? this.title[0] : this.title;
  }

  get cardSubtitles(): string[] {
    return Array.isArray(this.title) ? this.title.slice(1) : [];
  }
  get canShowAccessGloboButton(): boolean {
    return !!this.isAccessGloboButtonEnabled && !!this.blocked;
  }

  generateSrc(fileName: string): string {
    return UIUtil.generateImagePathbyFileName(fileName);
  }

  generateGradient(colorArray: string[]): string {
    return UIUtil.generateGradient(colorArray);
  }

  goToLink(link: string, blocked = false, externalLink = false): void {
    if (blocked) return;
    if (externalLink) {
      window.open(link, '_blank');
    } else {
      this.$router.push(link);
    }
  }
}
